import React from 'react';
import { Link } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import revenueImg from '../Assets/analysis-finance-grow.webp';
import portalImg from '../Assets/profile-bg.webp'; 
import theme from '../Shared/theme.js';
import TopBar from '../Layout/TopBar.jsx';
import '../Shared/LandingStyles.css'

const Landing = ({ user, onLogout }) => {


    return (
        <ThemeProvider theme={theme}>
            <div className="min-h-screen bg-gray-50">
                <TopBar username={user} onLogout={onLogout} />

                <main className="max-w-6xl mx-auto px-4 py-8">
                

                    <section className="feature-section">
      <h2 className="feature-heading">Explore your Dashboard, {user}</h2>
      <div className="card-grid">
        {/* Revenue Card */}
        <div className="feature-card revenue">
          <div className="pin-image">
            <img src={revenueImg} alt="Revenue Overview" />
          </div>
          <div className="card-content">
          <h3>Track Revenue & Commission</h3>
          <Link to="/layout" className="card-button">View Charts & Reports</Link>
        </div>
        </div>
        {/* Portal Access Card */}
        {/* <div className="feature-card portal">
          <div className="pin-image">
            <img src={portalImg} alt="Portal Tools Access" />
          </div>
          <div className="card-content">
          <h3>Access Main Portal</h3>
          <a href="https://www.jtaholidays.co.uk/profile.php" target="_blank"  className="card-button">Go to Portal</a>
        </div>
        </div> */}
      </div>
    </section>
                </main>
            </div>
        </ThemeProvider>
    );
};

export default Landing;
